import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../helpers/spinner";
import helperNumbers from "../../../../../helpers/numbers";
import helperTime from "../../../../../helpers/time";
import Pagination from "../../../../partials/content/Pagination";

export default function UsersUseThisGifts() {
  const [usersUseThisGifts, setUsersUseThisGifts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);

  const params = useParams();
  const giftID = params.giftID;

  useEffect(() => {
    getUsersUseThisGifts();
  }, [currentPage, countItemPerPage]);

  const getUsersUseThisGifts = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllGift = await sendRequestGetUsersUseThisGifts();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetAllGift) {
      return;
    }
    setUsersUseThisGifts(resultSendRequestGetAllGift.gift_user);
    setCountPage(resultSendRequestGetAllGift.count_page);
  };

  const sendRequestGetUsersUseThisGifts = async () => {
    let headersRequest = getHeaderForRequest();
    let usersUseThisGifts;
    try {
      usersUseThisGifts = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/gift/manage/users-use-this-gift/${giftID}?page=${currentPage}&number=${countItemPerPage}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return usersUseThisGifts.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateTable = () => {
    return (
      <>
        {usersUseThisGifts.map((userUseThisGifts, index) => {
          return (
            <tr>
              <td>{helperNumbers.toPersianNum(index + 1)}</td>
              <td>{helperNumbers.toPersianNum(userUseThisGifts.user_id)}</td>
              <td>{userUseThisGifts.first_name}</td>
              <td>{userUseThisGifts.last_name}</td>
              <td>
                {helperNumbers.toPersianNum(
                  helperTime.convertGregorianToJalali(
                    userUseThisGifts.created_at
                  ) +
                    " " +
                    userUseThisGifts.created_at.split(" ")[1]
                )}
              </td>
              <td>
                <Link
                  target={"_blank"}
                  to={`/user/show-info-user/${userUseThisGifts.user_id}`}
                  className="btn btn-info"
                >
                  اطلاعات بیشتر درباره کاربر
                </Link>
              </td>
            </tr>
          );
        })}
      </>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-finance" activeItem="all-gift" />
      <div className="content-wrapper">
        <section className="content-header pt-4 pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">
                  لیست کاربران استفاده کننده از هدیه
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link to="/finance/manage/all-gift" className="btn btn-primary">
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div className="table-responsive pt-2">
                <table className="table table-hilite tbl-td-white-space">
                  <thead>
                    <tr>
                      <td>#</td>
                      <td>شماره کاربری</td>
                      <td>نام</td>
                      <td>نام خانوادگی</td>
                      <td>تاریخ استفاده</td>
                      <td>عملیات</td>
                    </tr>
                  </thead>
                  <tbody>
                    {usersUseThisGifts.length > 0 && generateTable()}
                  </tbody>
                </table>
              </div>
              {countPage > 1 && generatePagination()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
